// maps-link.js
// Progressive enhancement for "Get directions" links.
//
// There is no single URL that opens whichever maps app a device prefers, so we
// ship a universal Google Maps href in the markup (works for everyone, even with
// JS disabled) and upgrade it here to the platform-native target:
//   - iOS / iPadOS / macOS  → Apple Maps  (maps.apple.com)
//   - Android               → geo: URI, which hands off to the user's default
//                             maps app via the system app chooser
//   - everything else       → left as the Google Maps href already in the HTML
//
// Usage: add data-maps-dest="..." (and optionally data-maps-label="Name") to an
// <a>. The dest may be either GPS coordinates ("LAT,LNG") or a free-form street
// address — both forms are handled. The element's existing href is the no-JS /
// desktop fallback.

// Matches a bare "lat,lng" pair (optionally with a space after the comma).
const COORDS_RE = /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/

function isCoords(dest) {
  return COORDS_RE.test(dest)
}

function appleMapsUrl(dest, label) {
  // daddr accepts both coordinates and address strings; just encode the value.
  const q = label ? `&q=${encodeURIComponent(label)}` : ""
  return `https://maps.apple.com/?daddr=${encodeURIComponent(dest)}&dirflg=d${q}`
}

function androidGeoUrl(dest, label) {
  if (isCoords(dest)) {
    const coords = dest.replace(/\s/g, "")
    // geo:lat,lng?q=lat,lng(Label) — the ?q copy gives the chooser a pin + name.
    const q = label ? `${coords}(${encodeURIComponent(label)})` : coords
    return `geo:${coords}?q=${q}`
  }
  // For an address, geo: needs the "0,0?q=ADDRESS" form so the app geocodes it.
  return `geo:0,0?q=${encodeURIComponent(dest)}`
}

export function initMapsLinks() {
  const ua = navigator.userAgent || ""
  // iPadOS 13+ reports as "Macintosh"; for our purposes both Mac and iOS should
  // go to Apple Maps anyway, so the broad match is intentional.
  const isApple = /iPhone|iPad|iPod|Macintosh/.test(ua)
  const isAndroid = /Android/.test(ua)

  document.querySelectorAll("a[data-maps-dest]").forEach((a) => {
    const dest = a.getAttribute("data-maps-dest")
    if (!dest) return
    const label = a.getAttribute("data-maps-label") || ""

    if (isApple) {
      a.href = appleMapsUrl(dest, label)
    } else if (isAndroid) {
      a.href = androidGeoUrl(dest, label)
    }
    // else: keep the Google Maps href baked into the markup.
  })
}
